import React from 'react';
import PropTypes from 'prop-types';
import AvailableResourcesSection from './AvailableResourcesSection/Content';

const AvailableResourcesSectionPicker = ({ relationship }) => {
  if (!relationship) {
    return null;
  }
  return (
    <AvailableResourcesSection relationship={relationship} />
  );
};

AvailableResourcesSectionPicker.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default AvailableResourcesSectionPicker;
